import script from "./CaseDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./CaseDetail.vue?vue&type=script&setup=true&lang=js"

import "./CaseDetail.vue?vue&type=style&index=0&id=ef3913c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef3913c2"]])

export default __exports__